import { buildCampaignUrl } from '@client/helpers/campaignUrl';
import { Tab, THB, ThbLinkType } from "@shared/types/campaign";
import { isSmScreen, isMdScreen } from '@client/helpers/screens';
import { TabIds, SM_TABS_OFFSET, MD_TABS_OFFSET, LG_TABS_OFFSET } from "./constants";

export const findActiveTab = (tabs: Tab[], id: string) => {
    const index = tabs.findIndex(tab => tab.id === id);
    if (index > -1) {
        return index;
    }
    const allTabIndex = tabs.findIndex(tab => tab.id === TabIds.ALL)
    return allTabIndex > -1 ? allTabIndex : 0;
}

export const getTabImagesMap = (tabs: Tab[], activeIndex: number, loaded: boolean) => {
    const result: {
        [k in number]: boolean;
    } = {};
    tabs.forEach((_, index) => {
        result[index] = index === activeIndex || loaded;
    })
    return result;
}

export const buildUrlForThb = (thb: THB, categoryId: string) => {
    switch (thb.type) {
        case ThbLinkType.CAMPAIGN:
            return buildCampaignUrl(thb.id, categoryId);
        case ThbLinkType.TAB:
            return `/event/${thb.id}${window.location.search}`;
        case ThbLinkType.URL:
            return thb.url;
        default:
            return undefined;
    }
};

export const getTopBreakpointOffset = (clientWidth: number) => {
    if (isSmScreen(clientWidth)) {
        return SM_TABS_OFFSET;
    }
    else if (isMdScreen(clientWidth)) {
        return MD_TABS_OFFSET;
    }

    return LG_TABS_OFFSET;
};
